<template>
    <div class="layout-wrapper">
        <div class="container-fluid">
            <div class="col-12">
                <div class="card shadow">
                    <div class="card-header  bg-accent-grad glow-accent text-center">
                        <h3 class="text-white">مدیریت کالا/خدمات</h3>

                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="card-header admin-header w-100">

                                <h5 class="text-accent-light">کالاها/خدمات</h5>
                                <!--<h5 class="text-accent-light" v-if="showArchive">(آرشیو شده)</h5>-->
                                <div class="text-left">
                                    <!--<button class="btn btn-link text-accent-lightt"-->
                                    <!--@click="onArchiveClicked()">-->
                                    <!--<i class="fa fa-eye" v-if="showArchive" title="عدم نمایش آرشیو ها"></i>-->
                                    <!--<i class="fa fa-eye-slash" v-else title="نمایش آرشیو ها"></i>-->
                                    <!--</button>-->
                                    <button class="btn btn-link text-accent-light"
                                            @click="onAddproductClicked()"><i class="fa fa-plus"></i>
                                    </button>
                                </div>
                            </div>

                            <div class="col-12 input-group round mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">جستجو</span>
                                </div>
                                <input class="form-control" v-model="search" @input="searching()"
                                       placeholder="حداقل 2 کاراکتر از نام کالا/خدمات را وارد کنید">
                            </div>
                            <div class="table-responsive">
                                <div v-if="!isLoading">
                                    <preloader/>
                                </div>
                                <div v-else>
                                    <div v-if="myproducts.length===0">
                                        <p class="text-center mt-3">هیچ کالا/خدمت ثبت نشده است. برای ثبت روی دکمه + کلیک
                                            کنید</p>

                                    </div>
                                    <div v-else>
                                        <table class="table table-hover table-striped mb-3">
                                            <thead>
                                            <tr>
                                                <th>کد کالا</th>
                                                <th>نام کالا</th>
                                                <th>شناسه مالیاتی</th>
                                                <th>واحد کالا</th>
                                                <th>ارزش افزوده</th>
                                                <th>دسته اصلی</th>
                                                <th>دسته فرعی</th>


                                                <th class="text-center">عملیات</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="it in myproducts">

                                                <td class="text-nowrap">{{it.productCode}}</td>
                                                <td class="text-wrap">{{it.productName}}</td>
                                                <td class="text-nowrap">{{it.taxCode}}</td>
                                                <td class="text-nowrap">{{it.unitName}}</td>
                                                <td class="text-nowrap">{{it.vatRate + it.avarezRate}}</td>
                                                <td class="text-nowrap">{{showMainCategory(it)}}</td>
                                                <td class="text-nowrap">{{showParentCategory(it)}}</td>
                                                <td class="text-center text-nowrap"><i
                                                        class="fa fa-pencil-square-o px-3 clickable"
                                                        style="font-size: larger"
                                                        @click="editProductItem(it)"
                                                        title="ویرایش آیتم"></i>
                                                    | <i class="fa fa-trash-o px-3 clickable"
                                                         style="font-size: larger"
                                                         @click="deleteProductItem(it)"
                                                         title="حذف آیتم"></i>

                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--///////////////////////////////////////////////////////////////////////////////////////////////////-->
            <modal show="false" ref="insertModal">
                <div class="row p-3">
                    <div class="col-12 text-center">
                        <h1 v-if="productMode === 'create'">ثبت محصول</h1>
                        <h1 v-else>ویرایش محصول</h1>
                    </div>
                    <div class="col-lg-4 ">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">دسته اصلی کالا</span>
                            </div>
                            <vs-select @onSearch="onDropDownFocused"
                                       @onSearchBlurred="onDropDownBlurred"
                                       ref="evidence"
                                       :data="maincategorys"
                                       :mode="'create'"
                                       :selected-val="filterMainCategory"
                                       :header="{multiple: false, label: 'categoryName'}"
                                       aria-placeholder="فیلتر براساس دسته کالا"
                                       @onChange="onMainCategoryChange"></vs-select>
                        </div>
                    </div>
                    <div class="col-lg-4 ">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">دسته فرعی کالا</span>
                            </div>
                            <vs-select @onSearch="onDropDownFocused"
                                       @onSearchBlurred="onDropDownBlurred"
                                       ref="evidence"
                                       :data="categorys"
                                       :mode="'create'"
                                       :selected-val="filterCategory"
                                       :header="{multiple: false, label: 'categoryName'}"
                                       aria-placeholder="فیلتر براساس دسته کالا"
                                       @onChange="onCategoryChange"></vs-select>
                        </div>
                    </div>

                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">کد کالا</span>
                            </div>
                            <input class="form-control" v-model="productModel.productCode">
                        </div>
                    </div>
                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">نام کالا</span>
                            </div>
                            <input class="form-control" v-model="productModel.productName">
                        </div>
                    </div>
                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">شناسه مالیاتی</span>
                            </div>
                            <input class="form-control" v-model="productModel.taxCode">
                        </div>
                    </div>
                    <div class="col-lg-4 ">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">واحد کالا</span>
                            </div>
                            <vs-select @onSearch="onDropDownFocused"
                                       @onSearchBlurred="onDropDownBlurred"

                                       ref="evidence"
                                       :data="units"
                                       :mode="'create'"
                                       :selected-val="filterUnit"
                                       :header="{multiple: false, label: 'unitName' }"
                                       aria-placeholder="فیلتر براساس واحد کالا"
                                       @onChange="onUnitChange"></vs-select>
                        </div>
                    </div>

                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">ارزش افزوده</span>
                            </div>
                            <input class="form-control" v-model="productModel.vatRate">
                        </div>
                    </div>
                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">عوارض ارزش افزوده</span>
                            </div>
                            <input class="form-control" v-model="productModel.avarezRate">
                        </div>
                    </div>

                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">کد فنی کالا</span>
                            </div>
                            <input class="form-control" v-model="productModel.technicalCode">
                        </div>
                    </div>
                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">بار کد</span>
                            </div>
                            <input class="form-control" v-model="productModel.barcode">
                        </div>
                    </div>
                    <div class="col-lg-8 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">توضیحات</span>
                            </div>
                            <input class="form-control" v-model="productModel.description">
                        </div>
                    </div>


                    <div class="col-lg-6 offset-lg-3 text-center">
                        <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                @click="updateproduct" v-if="productMode=='edit'">ویرایش محصول
                        </button>
                        <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                @click="createproduct" v-else>ثبت محصول
                        </button>
                        <button class="btn btn-primary btn-round clickable mt-3 mx-3"
                                @click="cancelproduct">انصراف
                        </button>
                    </div>
                </div>
            </modal>
            <!--////////////-->

        </div>
    </div>
</template>

<script>
    import BaseService from "../../_framework/api/BaseService";
    import DatePicker from '../../_framework/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import VsSelect from "../../_framework/VsSelect";
    import Utils from "../../_framework/utils/Utils";
    import Moment from 'moment-jalali';
    import Constants from "../../_framework/Constants";

    export default {
        name: "product",
        components: {VsSelect, DatePicker},
        data() {
            return {

                showArchive: false,
                isSending: false,
                isLoading: false,
                myproducts: [],


                productMode: "",
                productModel: {

                    id: 0,
                    description: "",
                    productName: "",
                    productCode: 0,
                    barcode: "",
                    technicalCode: "",
                    unitId: "",
                    mainCategoryId :"",
                    categoryId: "",
                    companyId: 0,
                    price: 0,
                    discount: 0,
                    taxCode: "",
                    vatRate: 0,
                    avarezRate: 0,

                },
                search: "",
                units: [],
                categorys: [],
                filterUnit: {},
                filterCategory: {},
                maincategorys: [],
                filterMainCategory: {},
                defaultcode:"",
                defualtmainCategoryCode:"",
                allCategorys : [],


            }
        },
        mounted() {
            this.getMyproducts();
            this.getUnits();
            this.getMainCategorys();
            this.getAllCategorys();

        },
        methods: {


            onAddproductClicked() {
                this.productModel = {
                    id: 0,
                    description: "",
                    productName: "",
                    productCode: 0,
                    barcode: "",
                    technicalCode: "",
                    unitId: "",
                    mainCategoryId:"",
                    categoryId: "",
                    companyId: 0,
                    price: 0,
                    discount: 0,
                    taxCode: "",
                    vatRate: 0,
                    avarezRate: 0,

                };
                this.filterMainCategory="";
                this.filterCategory="";
                this.productMode = "create";

                this.$refs.insertModal.showModal();
            },
            getAllCategorys(){
                new BaseService("category", "/GetCategory").getList().then(response => {

                    if (response.data.length > 0) {
                        this.allCategorys = response.data;
                    }
                }).catch(error => {

                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            getMyproducts() {
                new BaseService("product", "/Getproduct").getList().then(response => {
                    this.myproducts = response.data;
                    this.isLoading = true;

                }).catch(error => {

                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },

            getUnits() {
                new BaseService("unit", "/Getunit").getList().then(response => {
                    if (response.data.length > 0) {
                        this.units = response.data;
                        this.isLoading = true;
                    }
                }).catch(error => {

                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            onUnitChange(val) {

                if (val && val.unitName) {

                    this.filterUnit = val;
                    this.productModel.unitId = val.id;



                }
            },
            getCategorys(val) {
                if(val && val.id) {

                    new BaseService("Category", `/GetSecondCategory/${val.id}`).getList().then(response => {

                            this.categorys = response.data;




                    }).catch(error => {

                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                }
            },
            getMainCategorys() {
                new BaseService("category", "/GetMainCategory").getList().then(response => {

                    if (response.data.length > 0) {
                        this.maincategorys = response.data;
                    }
                }).catch(error => {

                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            onMainCategoryChange(val) {

                if (val ) {

                    this.filterMainCategory = val;
                    this.productModel.mainCategoryId= val.id;
                    if(this.productMode==="create"){
                        this.productModel.productCode=val.defaultCode;
                        this.defualtmainCategoryCode=val.defaultCode;
                    }
                    this.getCategorys(val);

                }
            },
            showMainCategory(val){
              if(val){
                  let catname="";

                  for(let cat of this.maincategorys){
                      if(parseInt(cat.id) ===parseInt(val.mainCategoryId)){
                          catname=cat.categoryName;
                          break;
                      }
                  }
                  return(catname);
              }
            },
            showParentCategory(val){
                if(val){
                    let catname="";

                    for(let cat of this.allCategorys){
                        if(parseInt(cat.id) ===parseInt(val.categoryId)){
                            catname=cat.categoryName;
                            break;
                        }
                    }
                    return(catname);
                }
            },

            onCategoryChange(val) {

                if (val ) {
                    this.filterCategory = val;

                    this.productModel.categoryId = val.id;
                    if (this.productMode === "create") {
                        this.productModel.productCode =this.defualtmainCategoryCode+"" +val.defaultCode;
                        this.defaultcode = val.defaultCode;
                        new BaseService("Product", `/GetLastCodeByDefault/${this.defaultcode}`).getList().then(respose => {
                            if(parseInt(respose.data)<=10) {
                                this.productModel.productCode =this.defaultcode+"000"+( respose.data + 1);
                            }else if(parseInt(respose.data)<=100) {
                                this.productModel.productCode =this.defaultcode+"00"+( respose.data + 1);
                            }else if(parseInt(respose.data)<=1000) {
                                this.productModel.productCode =this.defaultcode+"0"+( respose.data + 1);
                            }else {
                                this.productModel.productCode =( respose.data + 1);
                            }
                        }).catch(error => {

                            Utils.handleErrorWithNotification(error.data, this.$noty);
                        });
                    }

                }
            },
            editProductItem(item) {

                this.productMode = "edit";
                this.productModel.id = item.id;
                this.productModel.description = item.description;
                this.productModel.productName = item.productName;
                this.productModel.productCode = item.productCode;
                this.productModel.barcode = item.barcode;
                this.productModel.technicalCode = item.technicalCode;
                this.productModel.companyId = item.companeyId;
                this.productModel.price = item.price;
                this.productModel.discount = item.discount;
                this.productModel.taxCode = item.taxCode;
                this.productModel.vatRate = item.vatRate;
                this.productModel.avarezRate = item.avarezRate;
                this.filterUnit = { id : item.unitId , unitName : item.unitName};
                this.filterCategory = {id : item.categoryId ,categoryName : this.showParentCategory(item)};
                this.filterMainCategory = {id : item.mainCategoryId ,categoryName : this.showMainCategory(item)};
                this.productModel.unitId = item.unitId;
                this.productModel.categoryId = item.categoryId;


                this.$refs.insertModal.showModal();
            },
            deleteProductItem(item) {
                if (confirm("آیا از حذف این آیتم اطمینان دارید؟")) {
                    new BaseService("product", "Deleteproduct").delete(item.id).then(response => {
                        this.$noty.warning("آیتم با موفقیت حذف شد");
                        if (this.search.length > 1){
                            this.searching();
                        }else {
                            this.getMyproducts();
                        }
                    }).catch(error => {
                        Utils.handleErrorWithNotification("این آیتم در جای دیگری استفاده شده است، ابتدا موارد وابسته را پاک کنید", this.$noty);
                    })
                }
            },

            updateproduct() {

                this.isSending = true;
                if (this.productModel.mainCategoryId === null || this.productModel.mainCategoryId === undefined || this.filterMainCategory === ""
                    || this.productModel.mainCategoryId === 0) {
                    Utils.handleErrorWithNotification("لطفا دسته اصلی کالا را انتخاب کنید", this.$noty);
                    this.isSending = false;
                    return;
                }
                if (this.productModel.categoryId === null || this.productModel.categoryId === undefined || this.productModel.categoryId === ""
                    || this.productModel.categoryId === 0) {
                    Utils.handleErrorWithNotification("لطفا دسته فرعی کالا را انتخاب کنید", this.$noty);
                    this.isSending = false;
                    return;
                }
                if (this.productModel.productName === "" || this.productModel.productName === null || this.productModel.productName === undefined) {
                    Utils.handleErrorWithNotification("لطفا نام کالا را وارد نمائید", this.$noty);
                    this.isSending = false;
                    return;
                }
                if (this.productModel.unitId === "" || this.productModel.unitId === 0 || this.productModel.unitId === undefined) {
                    Utils.handleErrorWithNotification("لطفا واحد کالا را انتخاب کنید",this.$noty);
                    this.isSending = false;
                    return;
                }
                new BaseService("product", "/Updateproduct").update(this.productModel).then(response => {
                    this.$noty.success("محصول با موفقیت ویرایش شد");
                    this.isSending = false;
                    this.$refs.insertModal.hideModal();
                    if (this.search.length > 1){
                        this.searching();
                    }else {
                        this.getMyproducts();
                    }
                }).catch(error => {
                    this.isSending = false;
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                    this.$refs.insertModal.hideModal();
                    this.getMyproducts();
                });


            },
            createproduct() {

                this.isSending = true;
                if (this.productModel.mainCategoryId === null || this.productModel.mainCategoryId === undefined || this.filterMainCategory === ""
                    || this.productModel.mainCategoryId === 0) {
                    Utils.handleErrorWithNotification("لطفا دسته اصلی کالا را انتخاب کنید", this.$noty);
                    this.isSending = false;
                    return;
                }
                if (this.productModel.categoryId === null || this.productModel.categoryId === undefined || this.productModel.categoryId === ""
                    || this.productModel.categoryId === 0) {
                    Utils.handleErrorWithNotification("لطفا دسته فرعی کالا را انتخاب کنید", this.$noty);
                    this.isSending = false;
                    return;
                }
                if(this.productModel.productName==="" || this.productModel.productName===null || this.productModel.productName===undefined){
                    Utils.handleErrorWithNotification("لطفا نام کالا را وارد نمائید",this.$noty);
                    this.isSending=false;
                    return;
                }
                if(this.productModel.unitId ==="" || this.productModel.unitId===0 ||this.productModel.unitId===undefined){
                    Utils.handleErrorWithNotification("لطفا واحد کالا را انتخاب کنید",this.$noty);
                    this.isSending=false;
                    return;
                }

                new BaseService("product", "/Createproduct").create(this.productModel).then(response => {
                    this.$noty.success("محصول با موفقیت ثبت شد");
                    this.$refs.insertModal.hideModal();
                    this.isSending = false;
                    if (this.search.length > 1){
                        this.searching();
                    }else {
                        this.getMyproducts();
                    }

                    this.filterUnit = "";
                    this.filterCategory = "";
                }).catch(error => {
                    this.isSending = false;
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                    this.$refs.insertModal.hideModal();
                    this.getMyproducts();
                });

            },
            cancelproduct() {
                this.$refs.insertModal.hideModal();
                if (this.search.length > 1){
                    this.searching();
                }else {
                    this.getMyproducts();
                }
            },

            searching() {
                if (this.search.length > 1) {
                    this.isLoading = false;
                    new BaseService("product", `/Searchproduct/${this.search}`).getList().then(response => {


                        this.myproducts = response.data;
                        this.isLoading = true;
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                } else {
                    this.getMyproducts();
                }
            },


            thousandSepratorp(a) {
                let amount = this.productModel.price;
                if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
                    this.productModel.showprice = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else {
                    this.productModel.showprice = amount;
                }
            },
            thousandSepratord(a) {
                let amount = this.productModel.discount;
                if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
                    this.productModel.showdisc = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else {
                    this.productModel.showdisc = amount;
                }
            },


        }
    }
</script>

<style lang="scss" scoped>
    .profile-image {
        margin: 0 auto 1rem auto;
    }

    .profile-image img {
        max-width: 150px;
        border-radius: 1rem;
        box-shadow: 0 10px 25px -10px rgba(0, 0, 0, 0.25);
    }
</style>